export default class SliderStepByStep
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-slider-step-by-step',
      wrapper: 'data-slider-step-by-step-wrapper',
      arrows: 'data-slider-step-by-step-arrows',
      arrowLeft: 'data-slider-step-by-step-arrow-left',
      arrowRight: 'data-slider-step-by-step-arrow-right',
    };
    
    this.sliders = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.sliders) return;
    
    return true;
  }
  
  setEvents()
  {
    this.sliders.forEach(elWrapper => {
      const wrapper = elWrapper.querySelector(`[${this.settings.wrapper}]`);
      const settings = {
        container: wrapper,
        controls: false,
        slideBy: 1,
        autoplayText: ['', ''],
        autoplay: false,
        loop: true,
        touch: true,
        mouseDrag: true,
        autoHeight: true,
        nav: false,
        navPosition: 'bottom',
        items: 1,
      };
      
      const slider = this.initSlider(settings);
  
      elWrapper.querySelector(`[${this.settings.arrowLeft}]`).addEventListener('click', () => {
        slider.goTo('prev');
      });
  
      elWrapper.querySelector(`[${this.settings.arrowRight}]`).addEventListener('click', () => {
        slider.goTo('next');
      });
      
    })
  }
  
  initSlider(settings) {
    return tns(settings);
  }
}
